<div class="tw-flex tw-justify-around tw-items-center tw-h-[6rem] tw-my-auto">
    <div *ngFor="let item of data.items" (click)="itemSelected(item)" class="tw-flex tw-flex-col tw-justify-center tw-items-center tw-gap-8 tw-rounded tw-h-32 tw-w-32 tw-mt-2 tw-cursor-pointer hover:tw-bg-gray-300">
        <mat-icon *ngIf="item.icon" [svgIcon]="item.icon" class="tw-scale-[2.2] tw-translate-y-1/2"></mat-icon>
        <div *ngIf="item.label">{{item.label|translate}}</div>
    </div>
</div>
